import { showError } from 'helpers/handleError';
import { notifySuccess } from 'helpers/handleNotification';
import { isArray } from 'lodash';
import { takeLatest, takeEvery, put } from 'redux-saga/effects';
import types from 'redux/types';
import GuidelineServices from 'services/GuidelineServices';

function* getGuide() {
  try {
    const res = yield GuidelineServices.getGuide();
    if (isArray(res.data)) {
      yield put({ type: types.REQUEST_GET_GUIDE_SUCCESS, data: res.data });
    }
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_GET_GUIDE_FAILED, error });
  }
}

function* getGuideByRole(data) {
  const { role } = data;
  try {
    const res = yield GuidelineServices.getGuideByRole({ role });
    if (isArray(res.data)) {
      yield put({ type: types.REQUEST_GET_GUIDE_BY_ROLE_SUCCESS, data: res.data });
    }
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_GET_GUIDE_BY_ROLE_FAILED, error });
  }
}

function* saveGuide(data) {
  const { role, data: body, callbacks } = data;
  try {
    const res = yield GuidelineServices.saveGuideline(role, body);

    yield put({ type: types.REQUEST_SAVE_GUIDE_SUCCESS, role });
    notifySuccess('Update guideline successfully!');
    callbacks && callbacks.onSuccess(res);

    // Refetch the role's guideline list so the new item shows up immediately
    // without needing a route bounce. Dispatched through the watcher so
    // takeLatest semantics still apply.
    yield put({ type: types.REQUEST_GET_GUIDE_BY_ROLE, role });
  } catch (error) {
    callbacks && callbacks.onFailed(error);
    showError(error);
    yield put({ type: types.REQUEST_SAVE_GUIDE_FAILED, error, role });
  }
}

function* reorderGuide(data) {
  const { role, data: body = [], callbacks } = data;
  try {
    let listRequest = body.map((el) => GuidelineServices.saveGuideline(role, el));
    const res = yield Promise.all(listRequest);
    callbacks && callbacks.onSuccess(res);
  } catch (error) {
    callbacks && callbacks.onFailed(error);
    showError(error);
    yield put({ type: types.REQUEST_REORDER_GUIDE_FAILED, error, role });
  }
}

function* deleteGuide(data) {
  const { role, ids, callbacks } = data;
  try {
    const res = yield GuidelineServices.deleteGuideline(ids);
    notifySuccess('Deleted guideline successfully!');
    callbacks && callbacks.onSuccess(res);
  } catch (error) {
    callbacks && callbacks.onFailed(error);
    showError(error);
    yield put({ type: types.REQUEST_REORDER_GUIDE_FAILED, error, role });
  }
}

export default function* () {
  yield takeLatest(types.REQUEST_GET_GUIDE, getGuide);
  yield takeLatest(types.REQUEST_GET_GUIDE_BY_ROLE, getGuideByRole);
  yield takeEvery(types.REQUEST_SAVE_GUIDE, saveGuide);
  yield takeLatest(types.REQUEST_REORDER_GUIDE, reorderGuide);
  yield takeEvery(types.REQUEST_DELETE_GUIDE, deleteGuide);
}
